export const SET_LOGGED_IN_USER = "SET_LOGGED_IN_USER";
export const SET_TENANT = "SET_TENANT";
export const SET_CSRF_TOKEN = "SET_CSRF_TOKEN";
